var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm._m(0)
}
var staticRenderFns = [
  function() {
    var _vm = this,
      _c = _vm._self._c
    return _c("footer", { staticClass: "footer" }, [
      _c("div", { staticClass: "footer--whitelabel" }, [
        _c(
          "a",
          {
            staticClass: "footer-text",
            attrs: { href: "https://www.ringba.com/", target: "_BLANK" }
          },
          [_vm._v("Powered by Ringba")]
        )
      ])
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }